// We haven't added icon's computed property because it makes this mixin coupled with UI
export const togglePasswordVisibility = {
  data() {
    return {
      passwordFieldType: 'password',
    }
  },
  methods: {
    togglePasswordVisibility() {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
    },
  },
}

export const togglePasswordVisibilityTwo = {
  data() {
    return {
      passwordFieldType2: 'password',
    }
  },
  methods: {
    togglePasswordVisibilityTwo() {
      this.passwordFieldType2 = this.passwordFieldType2 === 'password' ? 'text' : 'password'
    },
  },
}

export const _ = null
